export { default } from './CopyClipboard.js';
